import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import {
  defaultMerchantCurrencyCode,
  type MerchantCurrencyCode,
} from "@/utils/currency"

export type OrganizationConfig = {
  beepaidGoEnabled: boolean
  orderAndBeepaidEnabled: boolean
  businessFundingEnabled: boolean
  donationsEnabled: boolean
  defaultCurrency: MerchantCurrencyCode
  terminalWebAppAuthRequired: boolean
}

export const retrieveSelfOrg = async () => {
  const { body } = await api.get<OrganizationConfig>(
    "/get-organization-config/"
  )
  return body
}

export const CURRENT_ORG_CONFIG_QUERY_KEY =
  "current_org_config"
export const useOrganizationConfig = () => {
  const { data } = useQuery({
    queryKey: [CURRENT_ORG_CONFIG_QUERY_KEY],
    queryFn: retrieveSelfOrg,
  })

  const defaultMerchantCurrency =
    computed<MerchantCurrencyCode>(
      () =>
        data.value?.defaultCurrency ??
        defaultMerchantCurrencyCode
    )

  return {
    organizationConfig: data,
    defaultMerchantCurrency,
  }
}
